var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"quick-actions__link",attrs:{"href":_vm.href,"target":_vm.target}},[_c('span',{staticClass:"quick-actions__title"},[_vm._t("title")],2),_vm._v(" "),_c('span',{staticClass:"quick-actions__description"},[_vm._t("description")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }